import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class CommunicationConfigService {
  constructor(private configService: ConfigService) {}

  getBackUri() {
    return this.configService.getOptions().api.uri;
  }

  getApiUri() {
    return `${this.getBackUri()}/api`;
  }

  getIdentifier() {
    return this.configService.getOptions().api.identifier;
  }
}
